import { useState } from "react";
import ServiceTitle from "@components/ProductPage/ProductServices/ServiceTitle";
import Heading from "@components/Heading";
import getConfig from "next/config";
import ProductServicesAfmForm from "./ProductServicesAfmForm";
import { formatPrice } from "@lib/helpers";
import Tooltip from "@components/Tooltip";
import Alert from "@components/Alert";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const getTypeId = (serviceKey) => settings.servicesCodes[serviceKey];

const CheckboxCheckedIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="10" height="10" rx="5" fill="#319D10" />
  </svg>
);

const Services = ({ services, activeServices, onServiceSelect }) => {
  const [showAfmForm, setShowAfmForm] = useState(false);

  const toggleAfmForm = () => {
    setShowAfmForm((prev) => !prev);
  };

  return (
    <div className="space-y-[16px]">
      {Object.entries(services).map(([serviceKey, servicesOptions]) => {
        return (
          <div key={serviceKey} className="bg-[#FFF9EB] p-[16px]">
            <div className="flex items-center">
              <Heading
                as="h3"
                display="h4"
                classesProp="text-[20px] leading-[24px]"
                title={<ServiceTitle serviceKey={serviceKey} />}
              />
            </div>
            <ul>
              {servicesOptions.map((serviceOption) => {
                const {
                  sku,
                  short_description,
                  name,
                  price,
                  product_links,
                  id,
                } = serviceOption;

                const hasVoucherService =
                  settings.serviceAFMVoucherSkus.includes(sku);

                return hasVoucherService ? (
                  <li key={`${serviceKey}-${sku}`} className="my-1 md:my-0">
                    <label
                      className="flex items-start md:mr-3 mt-2 font-normal cursor-pointer"
                      // onClick={toggleAfmForm}
                    >
                      <input
                        className="checkbox-input sr-only"
                        type="checkbox"
                        name={`product_services${serviceKey}`}
                        value={sku}
                        checked={showAfmForm}
                        onChange={toggleAfmForm}
                      />

                      <span
                        className={`checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white`}
                      >
                        <CheckboxCheckedIcon />
                      </span>

                      <div className=" text-base leading-5">
                        Voucher AFM “Rabla pentru electrocasnice”
                      </div>
                    </label>

                    {showAfmForm && (
                      <div className="ml-[30px] pb-[24px]">
                        <ProductServicesAfmForm
                          serviceClick={onServiceSelect}
                          serviceKey={serviceKey}
                          serviceOption={serviceOption}
                        />
                      </div>
                    )}
                  </li>
                ) : (
                  <li key={`${serviceKey}-${sku}`} className="my-1 md:my-0">
                    <label
                      className="flex items-start md:mr-3 mt-2 font-normal cursor-pointer"
                      htmlFor={`${serviceKey}-${sku}`}
                      // onClick={() => {
                      //   onServiceSelect({ serviceKey, sku });
                      // }}
                    >
                      <input
                        className="checkbox-input opacity-0 w-0 h-0"
                        type="checkbox"
                        id={`${serviceKey}-${sku}`}
                        name={`product_services${serviceKey}`}
                        value={sku}
                        checked={activeServices?.[serviceKey]?.sku === sku}
                        onChange={() => {
                          onServiceSelect({ serviceKey, sku });
                        }}
                      />

                      <span
                        className={`checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white`}
                      >
                        <CheckboxCheckedIcon />
                      </span>

                      <div className="flex flex-wrap gap-x-1 text-base leading-5">
                        {short_description ?? name}

                        {Boolean(price) && (
                          <span>{`- ${formatPrice(price)} lei`}</span>
                        )}

                        {serviceKey === "install" && (
                          <div className="ml-0.5">
                            <Tooltip content={name} />
                          </div>
                        )}
                      </div>
                    </label>

                    {product_links?.[serviceKey]?.length > 0 && (
                      <ul className="ml-6">
                        {product_links[serviceKey].map((childService) => (
                          <li
                            key={sku + childService.sku}
                            className="my-1 md:my-0"
                          >
                            <label className="flex items-start md:mr-3 mt-2 font-normal cursor-pointer">
                              <input
                                className="checkbox-input opacity-0 w-0 h-0"
                                type="checkbox"
                                name={`product_services[${getTypeId(
                                  serviceKey
                                )}].childService`}
                                value={id}
                                checked={
                                  activeServices?.[serviceKey]?.additional_data
                                    ?.childSku === childService.sku
                                }
                                onChange={() =>
                                  onServiceSelect({
                                    serviceKey,
                                    sku,
                                    additional_data: {
                                      childSku: childService.sku,
                                    },
                                  })
                                }
                              />

                              <span
                                className={`checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border bg-white`}
                              >
                                <CheckboxCheckedIcon />
                              </span>

                              <div className="flex flex-wrap gap-x-1 text-base leading-5">
                                {childService.name}

                                {childService &&
                                  Boolean(childService.price) && (
                                    <span>{`- ${formatPrice(
                                      childService.price
                                    )} lei`}</span>
                                  )}
                              </div>
                            </label>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>

            {serviceKey === "buyback" && (
              <div className="mt-[20px]">
                <Alert type="info" hasMinWidth={false} showIcon>
                  La ridicare, produsul trebuie sa fie deja deconectat de la
                  retele si dezinstalat.
                </Alert>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Services;
